import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Trash2 } from "lucide-react";

// The editable medicines table on the Consultation page — add/remove rows,
// edit each field. `medicines` items carry a stable `_key` (crypto.randomUUID())
// so React never confuses one row's input state with another's on add/remove.
export function ConsultationMedicinesSection({ medicines, setMedicines, EMPTY_MEDICINE }) {
  const updateMedicine = (i, field, value) => {
    setMedicines((meds) => meds.map((m, idx) => (idx === i ? { ...m, [field]: value } : m)));
  };

  return (
    <div className="mt-6 card-surface card-surface-hover rounded-xl border border-slate-200 bg-white shadow-sm p-6">
      <div className="flex items-center justify-between">
        <h2 className="font-semibold text-slate-900">Medicines</h2>
        <Button size="sm" variant="outline" className="gap-1" onClick={() => setMedicines((m) => [...m, { ...EMPTY_MEDICINE, _key: crypto.randomUUID() }])} data-testid="add-medicine-btn">
          <Plus className="h-4 w-4" /> Add Medicine
        </Button>
      </div>
      <div className="mt-4 space-y-3">
        {medicines.map((m, i) => (
          <div key={m._key} className="grid grid-cols-2 gap-2 rounded-lg border border-slate-200 p-3 sm:grid-cols-7" data-testid={`medicine-row-${i}`}>
            <Input placeholder="Name" data-testid={`medicine-name-${i}`} value={m.name} onChange={(e) => updateMedicine(i, "name", e.target.value)} />
            <Input placeholder="Strength" value={m.strength} onChange={(e) => updateMedicine(i, "strength", e.target.value)} />
            <Input placeholder="Dosage" value={m.dosage} onChange={(e) => updateMedicine(i, "dosage", e.target.value)} />
            <Input placeholder="Frequency" value={m.frequency} onChange={(e) => updateMedicine(i, "frequency", e.target.value)} />
            <Input placeholder="Before/After Food" value={m.food_timing} onChange={(e) => updateMedicine(i, "food_timing", e.target.value)} />
            <Input placeholder="Duration" value={m.duration} onChange={(e) => updateMedicine(i, "duration", e.target.value)} />
            <div className="flex items-center gap-1">
              <Input placeholder="Instructions" value={m.instructions} onChange={(e) => updateMedicine(i, "instructions", e.target.value)} />
              <button data-testid={`remove-medicine-${i}`} onClick={() => setMedicines((meds) => meds.filter((_, idx) => idx !== i))} className="text-slate-400 hover:text-red-600">
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
